import { forwardRef } from 'react';
import { useFormContext, Controller, FieldValues, RegisterOptions } from 'react-hook-form';
import { InputAutocompleteProps } from '../input-autocomplete';
import { InputAutocomplete, InputAutocompleteOption } from '../input-autocomplete';
import { getNestedErrorForm } from './form.utils';
import { InputSelect } from '../input-select';
import { InputSelectOption } from '../input-date-select/types/InputDateSelectTransformerTypes';

interface ControllerInputSelectProps extends InputAutocompleteProps {
	name: string;
	options: InputAutocompleteOption[];
	regexCleaner?: RegExp;
	label: string;
	information?: string;
	triggersName?: string | string[] | undefined;
	rules?:
		| Omit<RegisterOptions<FieldValues, string>, 'disabled' | 'valueAsNumber' | 'valueAsDate' | 'setValueAs'>
		| undefined;
	autocomplete?: boolean;
	onChange?: (((newValue: InputAutocompleteOption) => void) & ((newValue: InputSelectOption) => void)) | undefined;
}
export const ControllerInputSelect = forwardRef<HTMLInputElement, ControllerInputSelectProps>(
	function ControllerInputSelect(
		{ name, label, options, rules, triggersName, autocomplete = true, onChange, ...props },
		ref
	) {
		const {
			trigger,
			control,
			formState: { errors },
			getValues
		} = useFormContext<FieldValues>();

		const ComponentToRender = autocomplete ? InputAutocomplete : InputSelect;

		return (
			<Controller
				name={name}
				control={control}
				rules={rules}
				render={({ field }) => (
					<ComponentToRender
						{...field}
						{...props}
						ref={ref}
						onChange={(e) => {
							field.onChange(e);
							triggersName && getValues(triggersName.toString()) && void trigger(triggersName);
							onChange ? onChange(e) : null;
						}}
						data-testid="controller-input-autocomplete"
						label={label}
						options={options}
						errorMessage={getNestedErrorForm(errors, name)?.message}
					/>
				)}
			/>
		);
	}
);
